import { render, staticRenderFns } from "./TextareaEmojiPicker.vue?vue&type=template&id=43310fa5&scoped=true&"
import script from "./TextareaEmojiPicker.vue?vue&type=script&lang=js&"
export * from "./TextareaEmojiPicker.vue?vue&type=script&lang=js&"
import style0 from "./TextareaEmojiPicker.vue?vue&type=style&index=0&id=43310fa5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43310fa5",
  null
  
)

export default component.exports